<app-header></app-header>
<app-loader></app-loader>
<router-outlet></router-outlet>
<app-newsletter></app-newsletter>
<app-footer></app-footer>


<!-- start loader -->
  <!-- @if(loading()) {
    <div class="loader-wrapper">
        <div class="loader">
        </div>
        <div class="loader-section section-left"></div>
        <div class="loader-section section-right"></div>
    </div>
} -->
<!-- End loader -->
<!-- start back to top -->

<div #progressWrap class="progress-wrap"
     [class.active-progress]="showBackToTop"
     (click)="scrollToTop()">
  <svg class="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
    <path #progressPath d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
  </svg>
</div>

<!-- end back to top -->



    <!-- progress Back to top End -->

<!-- start modal -->
 